package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.GET_MERCHANT_REPUTATION
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class GetMerchantReputationRequestModel(
    val merchantId: Long
) : BaseRequestModel(api = GET_MERCHANT_REPUTATION)

